import React, {useState, useEffect} from 'react';
import PropTypes, {oneOfType} from 'prop-types';
import {Button, DatePicker, List} from 'antd-mobile';
import './style.less';

const {Item} = List;

const transformDateTip = {
  begin: '开始日期',
  end: '结束日期',
  selectDate: '选择日期'
};

const transformDatePlaceholder = {
  begin: '请选择开始日期',
  end: '请选择结束日期',
  selectDate: '请选择日期'
};

export default function FilterContent(props) {
  const {tabIndex = 0, onChange, viewModel: viewModelProps = [], isTab} = props;
  const [viewModel, setViewModel] = useState(viewModelProps);
  const [tabIndexState, setTabIndex] = useState(tabIndex);
  const [filterType, setFilterType] = useState('default');
  const [dates, setDates] = useState({});
  const [dataModel, setDataModel] = useState({});

  const isDateType = filterType.includes('date');
  const dataRange = filterType === 'dateRange' ? ['begin', 'end'] : ['selectDate'];

  const dateModel = () => {
    if (!isDateType) return {};

    return dataRange.reduce((total, current) => {
      if (typeof total === 'string') return {[total]: undefined, [current]: undefined};
      return total[current] = undefined;
    })
  }

  useEffect(() => {
    setDates(dateModel());
  }, [filterType]);

  useEffect(() => {
    onChange && onChange(viewModel, tabIndexState);
  });


  const selectFilterTitle = (value = {}, index) => {
    setTabIndex(index);
    const {content = [], type, title, key} = value;
    setFilterType(key);
  }

  const selectFilterItem = (values = {}, index, title, mode) => {
    const currentItem = viewModel.find(v => v.title === title);
    const {content = [], dateRange = []} = currentItem;
    if (mode === 'multi') {
      content[index].selected = !content[index].selected;
    } else {
      content.forEach((v, i)=> {
        if (i === index) {
          return content[index].selected = !content[index].selected;
        }
        delete content[i].selected;
      })
    }

    if (dateRange.length) {
      dateRange.forEach(v => (delete v.date));
    }

    setViewModel([...viewModel]);
  }

  const dateSelect = (date, i, title, value) => {
    const currentItem = viewModel.find(v => v.title === title);
    const {dateRange = [], content = []} = currentItem;
    dateRange[i].date = date;
    if (dateRange.length === 2) {
      const {value} = dateRange[i] || {};
      if (value === 'begin') {
        dateRange[1].minDate = date;
        delete dateRange[1].maxDate;
      } else {
        dateRange[0].maxDate = date;
        delete dateRange[0].minDate;
      }
    }

    if (content.length) {
      content.forEach(v => (delete v.selected));
    }

    setViewModel([...viewModel]);
  }

  const createSelectItem = (content, title, index) => {
    const style = isTab ? {display: tabIndexState === index ? 'block' : 'none'} : {};

    return <div
      className='form-item'
      style={style}
      key={index}
    >
      {!isTab && <h1>{title}</h1>}
      <div className='form-item-content'>
        {content.map((v, i) =>
        <Button
          className='select-filter-item'
          onClick={() => selectFilterItem(v, i, title)}
          key={i}
          type={v.selected ? 'primary' : undefined}
        >{v.label}</Button>)}
      </div>
    </div>
  }

  const createDate = ({content, dateRange}, title, index) => {
    const style = isTab ? {display: tabIndexState === index ? 'block' : 'none'} : {};
    return <div
      className='form-item'
      style={style}
      key={index}
    >
      {!isTab && <h1>{title}</h1>}
      <div className='form-item-content'>
      {content.map((v, i) =>
        <Button
          className='select-filter-item'
          onClick={() => selectFilterItem(v, i, title)}
          key={i}
          type={v.selected ? 'primary' : undefined}
        >{v.label}</Button>)}
      </div>
      <div className='form-item-date'>
        {dateRange.map((v, i) =>
          <div
            className={`date-picker ${v.date ? 'seted-date-picker' : ''}`}
            key={i}
          >
            <DatePicker
              mode="date"
              title={transformDatePlaceholder[v.value]}
              extra={transformDatePlaceholder[v.value]}
              key={i}
              value={v.date}
              maxDate={v.maxDate}
              minDate={v.minDate}
              onChange={date => dateSelect(date, i, title, v) }
            >
              <Item arrow="horizontal" />
            </DatePicker>
          </div>)}
        {dateRange.length === 2 && <span className='date-picker-text'>至</span>}
      </div>

    </div>
  }

  const createNode = () => {
    return viewModel.map((v, i) => {
      const {title, type, content = [], dateRange = []} = v;
      if (type === '') {
        return createSelectItem(content, title, i);
      } else {
        return createDate({content, dateRange}, title, i);
      }
    })
  }

  return (
    <div>
      {isTab && <div className='filter-content-title'>
        {viewModel.map((v, i) => <Button
          onClick={() => selectFilterTitle(v, i)}
          key={v.title}
          type={filterType === v.key ? 'primary' : undefined}
        >{v.title}</Button>)}
      </div>}
      <div className='filter-content-container'>
        {createNode()}
      </div>
    </div>
  );
}
